import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import EDocsLogo from '../ui/EDocsLogo';

function ErrorPage({ error }) {
	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			minHeight="100vh"
			bgcolor="grey"
		>
			<Box
				display="flex"
				flexDirection="column"
				alignItems="center"
				bgcolor="white"
				padding={5}
				borderRadius={2}
				boxShadow={3}
				width="fit-content"
			>
				<Box width="100%">
					<EDocsLogo style={{ width: '100%' }} />
				</Box>
				<Alert severity="error" style={{ width: '100%' }}>
					<AlertTitle>Error</AlertTitle>
					{error}
				</Alert>
			</Box>
		</Box>
	);
}

export default ErrorPage;